import mutations from './mutations'
import * as actions from './actions'

const state = {
  new_resolution: {
    displayName: '',
    quoteStatusCategoryTypeID: '',
    isActive: true
  },
  resolutions: [
  ],
  dispositionTypes: [],
  selectedResolution : {},
  activeDispositions: [],
  activefollowupResultTypes: []
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dispositions/index.js